import "./App.css";
import React, { useEffect } from "react";
import HeaderImageTransition from "./components/Home";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation
} from "react-router-dom";
import ScrollToTopButton from "./components/ScrollToTopButton";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Aboutus from "./components/Aboutus";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import Contact from "./components/Contact";
import ContactForm from "./components/ContactForm";
import TitleManager from "./components/TitleManager";
import Uiux from "./components/UIUXDesign";
import AppDev from "./components/AppDev";
import WebDev from "./components/WebDev";
import DigitalMarketing from "./components/DigitalMarketing";
import DeleteAccount from "./components/DeleteAccount";
import { ToastContainer } from "react-toastify";
import Seoservices from "./components/Seoservices";
import Socialmm from "./components/Socialmm";
import Ecommerce from "./components/Ecommerce";
import Wordpress from "./components/Wordpress";
import Services from "./components/Services";
import RequestCall from "./components/Requestcall";
import Phpdev from "./components/Phpdev";
import Laradev from "./components/Laradev";
import Reacdev from "./components/Reacdev";
import Pythodev from "./components/Pythodev";
import Flutdev from "./components/Flutdev";
import Noddev from "./components/Noddev";
import Qaeng from "./components/Qaeng";
import Customsoso from "./components/Customsoso";
import ClickSpark from "./components/ClickSpark";
import ScrollVelocity from "./components/ScrollLine/ScrolLine";
import ScrollProgress from "./components/ScrollProgress";
import Portfolio from "./components/Portfolio";
import PaymentPolicy from "./components/PaymentPolicy";
import Crm from "./components/Crm";
import Pos from "./components/Pos";
import RealEstate from "./components/RealEstate";
import RentalBook from "./components/RentalBook";
import SingleVendor from "./components/SingleVendor";
import MultiVendor from "./components/MultiVendor";
import Triprex from "./components/Triprex";
import Lms from "./components/Lms";
import HomecoProd from "./components/HomecoProd";
import EventTime from "./components/EventTime";
import Onest from "./components/Onest";
import Aifsd from "./components/Aifsd";
import Zaiproty from "./components/Zaiproty";
import Jobpilot from "./components/Jobpilot";
import LaraBid from "./components/LaraBid";
import RioRelax from "./components/RioRelax";
import SkillGro from "./components/SkillGro.jsx";
import Doctorly from "./components/Doctorly.jsx";
import MatriLab from "./components/MatriLab.jsx";
import Aabcserv from "./components/Aabcserv.jsx";
import Foodefy from "./components/Foodefy.jsx";
import ITCompanyBlog from "./components/Blogs.jsx";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollVelocity />
        <ClickSpark
          sparkColor="#137eb1"
          sparkSize={10}
          sparkRadius={15}
          sparkCount={8}
          duration={400}
        >
          <ScrollToTop />
          <TitleManager />
          <ToastContainer position="top-right" autoClose={3000} />
          <Navbar />
          <ScrollProgress />
          <Routes>
            <Route path="/" element={<HeaderImageTransition />} />
            <Route path="/aboutus/" element={<Aboutus />} />
            <Route path="/privacypolicy/" element={<PrivacyPolicy />} />
            <Route path="/paymentpolicy/" element={<PaymentPolicy />} />
            <Route
              path="/termsandconditions/"
              element={<TermsAndConditions />}
            />
            <Route path="/contact" element={<Contact />} />
            <Route path="/contactform" element={<ContactForm />} />
            <Route path="/uiuxdesign" element={<Uiux />} />
            <Route
              path="/mobile-application-development"
              element={<AppDev />}
            />
            <Route path="/web-development" element={<WebDev />} />
            <Route path="/digital-marketing" element={<DigitalMarketing />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/seoservices" element={<Seoservices />} />
            <Route path="/social-media-marketing" element={<Socialmm />} />
            <Route path="/e-commerce" element={<Ecommerce />} />
            <Route path="/wordpress" element={<Wordpress />} />
            <Route path="/services/" element={<Services />} />
            <Route path="/php-dev" element={<Phpdev />} />
            <Route path="/laravel-dev" element={<Laradev />} />
            <Route path="/react-dev" element={<Reacdev />} />
            <Route path="/python-dev" element={<Pythodev />} />
            <Route path="/flutter-dev" element={<Flutdev />} />
            <Route path="/node-dev" element={<Noddev />} />
            <Route path="/qa-engineers" element={<Qaeng />} />
            <Route path="/customsoftwaresolution" element={<Customsoso />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/crm" element={<Crm />} />
            <Route path="/pos" element={<Pos />} />
            <Route path="/real-estate" element={<RealEstate />} />
            <Route path="/rental-booking" element={<RentalBook />} />
            <Route path="/single-vendor" element={<SingleVendor />} />
            <Route path="/multi-vendor" element={<MultiVendor />} />
            <Route path="/travelagencyandtourbooking" element={<Triprex />} />
            <Route path="/lms" element={<Lms />} />
            <Route path="/realestatedirectory" element={<HomecoProd />} />
            <Route path="/event-management" element={<EventTime />} />
            <Route path="/mp-lms" element={<Onest />} />
            <Route path="/aifsd" element={<Aifsd />} />
            <Route path="/mpproperty" element={<Zaiproty />} />
            <Route path="/mpjobs" element={<Jobpilot />} />
            <Route path="/mpbid" element={<LaraBid />} />
            <Route path="/mprelax" element={<RioRelax />} />
            <Route path="/mpskills" element={<SkillGro />} />
            <Route path="/mpdoctor" element={<Doctorly />} />
            <Route path="/mpmatrimony" element={<MatriLab />} />
            <Route path="/mpdemand" element={<Aabcserv />} />
            <Route path="/mpfood" element={<Foodefy />} />
            <Route path="/blogs" element={<ITCompanyBlog />} />
          </Routes>
          <Footer />
          <RequestCall />
          <ScrollToTopButton />
        </ClickSpark>
      </div>
    </Router>

    // const useTawkTo = () => {
    //   useEffect(() => {
    //     const script = document.createElement("script");
    //     script.type = "text/javascript";
    //     script.async = true;
    //     script.src = "https://embed.tawk.to/67ea8cde899a5219089536ca/1inm3cht5";
    //     script.charset = "UTF-8";
    //     script.setAttribute("crossorigin", "*");
    //     document.body.appendChild(script);

    //     return () => {
    //       document.body.removeChild(script);
    //     };
    //   }, []);
    // };

    // useTawkTo();
  );
}

export default App;
